import React from "react";
import { Link } from "react-router-dom";

function PlantelRosterSection({ title, players = [] }) {
    if (!players.length) {
        return null;
    }

    return (
        <div>
            <h4 className="text-[10px] sm:text-[11px] font-black text-green-500 uppercase tracking-[0.18em] mb-2 sm:mb-3 border-b border-white/10 pb-1">
                {title}
            </h4>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-1 sm:gap-2">
                {players.map((player, index) => (
                    (() => {
                        const isCortado = String(player?.observacion || "").toLowerCase() === "cortado";

                        return (
                    <Link
                        key={`${player?.nombre || "jugador"}-${index}`}
                        to={`/jugador/${encodeURIComponent(player?.nombre || "")}`}
                        className="flex items-center rounded border border-transparent bg-white/0 px-2 py-1.5 sm:py-1 hover:bg-white/5 hover:border-white/10 transition-colors active:bg-white/10 min-w-0"
                    >
                        <div className="min-w-0 flex items-center gap-1.5 flex-wrap">
                            <p className="text-[13px] sm:text-sm font-bold text-slate-100 break-words leading-tight">
                                {player?.nombre || "-"}
                            </p>
                            {player?.observacion && (
                                <span className={`shrink-0 text-[9px] sm:text-[10px] font-bold px-1.5 py-0.5 rounded ${isCortado ? "text-red-300 border border-red-500/70" : "text-slate-400 border border-white/15"}`}>
                                    {player.observacion}
                                </span>
                            )}
                        </div>
                    </Link>
                        );
                    })()
                ))}
            </div>
        </div>
    );
}

export default PlantelRosterSection;
